module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp13_5012.40fcc8b7.png";